const dimensions = {
  mobileWidth: '224px',
  mobileHeight: '290px',
  desktopWidth: '830px',
  desktopHeight: '340px'
};

export default dimensions;
